<template>
    <syuugyou-kisoku-detail />
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import Detail from '@/components/syuugyoukisoku/Detail.vue'

export default defineComponent({
    setup() {
      return {}
    },
    components: {
      'syuugyou-kisoku-detail': Detail
    }
})
</script>
